import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
	MatButtonModule,
	MatDialogModule,
	MatDividerModule,
	MatFormFieldModule,
	MatIconModule,
	MatInputModule,
	MatSnackBarModule,
	MatTooltipModule,
	MatSelectModule
} from '@angular/material';
import { ConfirmDialogModule } from '../confirm-dialog/confirm-dialog.module';
import { ShowHistoryDialogModule } from '../show-history-dialog/show-history-dialog.module';
import { EditCategoryDialogComponent } from './edit-category-dialog/edit-category-dialog.component';
import { EditLabelComponent } from './edit-label/edit-label.component';
import { LabelHistoryComponent } from './edit-label/label-history/label-history.component';
import { NodeModule } from './edit-label/node/node.module';
import { CategoryComponent } from './label-category/label-category.component';
import { LabelForEditComponent } from './label-category/label-for-edit/label-for-edit.component';
import { LabelManagerComponent } from './label-manager.component';
import { AceEditorModule } from 'ng2-ace-editor';

@NgModule({
	declarations: [
		LabelManagerComponent,
		CategoryComponent,
		LabelForEditComponent,
		EditCategoryDialogComponent,
		EditLabelComponent,
		LabelHistoryComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		MatIconModule,
		MatInputModule,
		MatDividerModule,
		MatSnackBarModule,
		MatButtonModule,
		MatDialogModule,
		MatTooltipModule,
		MatFormFieldModule,
		MatSelectModule,
		AceEditorModule,
		ConfirmDialogModule,
		DragDropModule,
		NodeModule,
		ShowHistoryDialogModule
	],
	exports: [LabelManagerComponent],
	entryComponents: [EditCategoryDialogComponent, LabelHistoryComponent, EditLabelComponent],
	schemas: [NO_ERRORS_SCHEMA]
})
export class LabelManagerModule {}
